import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '../../../auth/services/auth.service';
import { COMMON_IMPORTS } from '../../../../shared/imports/common-imports';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatToolbarModule, COMMON_IMPORTS],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  userData = {
    name: '',
    prid: '',
  };

  constructor(private readonly authService: AuthService) {}

  ngOnInit() {
    this.authService.getUserBySession().subscribe((user) => {
      if (user) {
        this.userData.name = `${user.payload.firstname} ${user.payload.lastname}`;
        this.userData.prid = user.payload.prid;
      }
    });
  }
}
